export default __webpack_public_path__ + "static/media/mail.d94f2c7d.svg";